const LocalStorageKeys = {
	expandedDownloadPanels: 'expandedDownloadPanels',
	expandedRequestsPanels: 'expandedRequestsPanels',
	expandedReviewsPanels: 'expandedReviewsPanels',
	expandedShelfPanels: 'expandedShelfPanels',
	collaborativeListViewPreference: 'collaborativeListViewPreference',
};

export default LocalStorageKeys;
